//#region src/kiosk_battery_state.ts
var KioskBatteryState = /* @__PURE__ */ function(KioskBatteryState) {
	KioskBatteryState[KioskBatteryState["UNKNOWN"] = 0] = "UNKNOWN";
	KioskBatteryState[KioskBatteryState["UNPLUGGED"] = 1] = "UNPLUGGED";
	KioskBatteryState[KioskBatteryState["CHARGING"] = 2] = "CHARGING";
	KioskBatteryState[KioskBatteryState["FULL"] = 3] = "FULL";
	return KioskBatteryState;
}(KioskBatteryState || {});
//#endregion
export { KioskBatteryState };

//# sourceMappingURL=kiosk_battery_state.js.map